import React from 'react';
import { Button, Stack, Typography } from '@mui/material';

/**
 * "Showing X–Y of N" plus prev/next. Stateless — parent owns `page`
 * and `totalPages`.
 */
export default function OrderPager({ page, pageSize, total, totalPages, loading, onPage }) {
  return (
    <Stack
      direction='row'
      alignItems='center'
      justifyContent='space-between'
      flexWrap='wrap'
      gap='8px'
      mt='12px'
    >
      <Typography variant='caption' color='text.secondary'>
        {total === 0
          ? 'No matching orders'
          : `Showing ${(page - 1) * pageSize + 1}–${Math.min(total, page * pageSize)} of ${total}`}
      </Typography>
      <Stack direction='row' spacing='6px' alignItems='center' flexWrap='wrap'>
        <Button
          size='small'
          variant='outlined'
          disabled={page <= 1 || loading}
          onClick={() => onPage(Math.max(1, page - 1))}
        >
          Prev
        </Button>
        <Typography variant='caption' color='text.secondary'>
          Page {page} / {totalPages}
        </Typography>
        <Button
          size='small'
          variant='outlined'
          disabled={page >= totalPages || loading}
          onClick={() => onPage(Math.min(totalPages, page + 1))}
        >
          Next
        </Button>
      </Stack>
    </Stack>
  );
}
